import Apptimize from '@apptimize/apptimize-web-sdk'

import featureFlags from 'const/featureFlags'

/*
 * Update local featureflags with apptimize only when apptimize is initialized and env is prod
 * Update isFeatureFlagsFetched only when apptimize is initialized
 * If apptimize is not initialized, fallback to local featureflags
 */

const updateFeatureFlags = (
  setIsFeatureFlagsFetched: (flag: boolean) => void,
  isApptimizeInitialized: boolean
) => {
  if (isApptimizeInitialized) {
    if (process.env.NODE_ENV === 'production') {
      Object.keys(featureFlags).forEach((flag: string) => {
        featureFlags[flag] = Apptimize.isFeatureFlagEnabled(flag)
      })
    }
    setIsFeatureFlagsFetched(true)
  }
}

export default updateFeatureFlags
